<template>
  <transition name="fade">
    <div class="introAnimation" v-if="flag_animation">
      <div class="introAnimation-black-div"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "introAnimation",
  data() {
    return {
      flag_animation: false,
    };
  },
  beforeMount: function () {
    this.flag_animation = true;
    var aux = this;
    // setTimeout(function () {
    //   aux.flag_animation = false;
    // }, 7000);
  },
};
</script>